import { useQuery } from 'urql';

import { useGetLoggedInUser } from '@revelio/auth';
import { GetReportConfig, Tab } from '@revelio/data-access';

/**
 * `reports_validation` is only served to clients with the reports tab; asking
 * for it without that permission errors out. The global AI assistant mounts on
 * every page, so this has to be paused at the query rather than per-page.
 */
export const useReportConfigQuery = () => {
  const { loggedInUser } = useGetLoggedInUser();
  const hasReportsTab = !!loggedInUser?.tabs?.includes(Tab.Reports);

  return useQuery({
    query: GetReportConfig,
    pause: !hasReportsTab,
  });
};
